import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { changeBookBackgroundType } from './../../../../../../redux/actions/ui/bookProperties';
import { TEMATIC } from '../../../../../../helpers/dropHelper';


class ParentCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
    };
  }

  componentDidMount() {
    const { lang } = this.props;
    this.setState({
      categories: [
        {
          value: lang.tematic,
          name: TEMATIC,
        },
      ],
    });
    this.setBackgroundType(TEMATIC);
  }

  setBackgroundType = (type) => {
    this.props.dispatch(changeBookBackgroundType(type));
  }


  displayComponent = () => this.state.categories.map((element, index) => <li key={`parent-${index}`} onClick={() => { this.setBackgroundType(element.name); }} >{element.value}</li>)

  render() {
    return (
      <div className="listBody ">
        <ol>
          {this.displayComponent()}
        </ol>
      </div>

    );
  }
}

ParentCategory.defaultProps = {
  dimensions: {},
  lang: {},
};

ParentCategory.propTypes = {
  dimensions: PropTypes.object,
  lang: PropTypes.object,
};

export default connect()(ParentCategory);




// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/parent-category/ParentCategory.jsx